import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaSave, FaArrowLeft, FaUser, FaPhone } from "react-icons/fa";
import axiosInstance from "../../utils/axiosInstance";
import "./CreateVendor.css";

export default function VendorForm() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    vendorName: "",
    phoneNo: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  /* Fetch vendor for edit */
  useEffect(() => {
    if (id) {
      setPageLoading(true);
      axiosInstance
        .get(`/getVendorById/${id}`)
        .then(res => {
          setFormData({
            vendorName: res.data.vendorName || "",
            phoneNo: res.data.phoneNo || ""
          });
        })
        .finally(() => setPageLoading(false));
    }
  }, [id]);

  const validate = () => {
    const newErrors = {};
    if (!formData.vendorName.trim()) newErrors.vendorName = "Vendor name is required";
    if (!formData.phoneNo.trim()) newErrors.phoneNo = "Phone number is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setLoading(true);
      id
        ? await axiosInstance.put(`/updateVendor/${id}`, formData)
        : await axiosInstance.post("/createVendor", formData);

      navigate("/vendors");
    } catch {
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return <div className="form-loader">Loading vendor details...</div>;
  }

  return (
    <div className="create-vendor-container">
      <div className="vendor-card">

        {/* Header */}
        <div className="vendor-card-header">
          
          <button className="btn-back" onClick={() => navigate(-1)}>
            <FaArrowLeft /> Back
          </button>
          <div>
            <h2>{id ? "Edit Vendor" : "Create Vendor"}</h2>
            <p className="subtitle">Vendor information</p>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="vendor-form">

          <div className={`form-group ${errors.vendorName ? "has-error" : ""}`}>
            <label>Vendor Name</label>
            <div className="input-wrapper">
              <FaUser className="input-icon" />
              <input
                type="text"
                name="vendorName"
                value={formData.vendorName}
                onChange={handleChange}
                placeholder="Enter vendor name"
              />
            </div>
            {errors.vendorName && <span className="error-text">{errors.vendorName}</span>}
          </div>

          <div className={`form-group ${errors.phoneNo ? "has-error" : ""}`}>
            <label>Phone Number</label>
            <div className="input-wrapper">
              <FaPhone className="input-icon" />
              <input
                type="text"
                name="phoneNo"
                value={formData.phoneNo}
                onChange={handleChange}
                placeholder="Enter phone number"
              />
            </div>
            {errors.phoneNo && <span className="error-text">{errors.phoneNo}</span>}
          </div>

          <div className="form-actions">
            <button className="btn-save" disabled={loading}>
              <FaSave />
              {loading ? "Saving..." : id ? "Update Vendor" : "Save Vendor"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}
